// ** Redux Imports
import { createSlice, createAsyncThunk, current, createDraftSafeSelector } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

import { paginate } from '../../../../utility/Utils'
import { orderBy } from 'lodash'

export const getAllData = createAsyncThunk('appUsers/getAllData', async () => {
  const response = await axios.get('/v1/users')
  response.data.forEach(user => {
    if (!user?.salary?.amount) {
      user.salary.amount = 0
    }
  })
  return response.data
})

export const getCustomers = createAsyncThunk('appUsers/getCustomers', async () => {
  const response = await axios.get(`/v1/config/customers`)
  return response.data
})

export const appUsersSlice = createSlice({
  name: 'employees',
  initialState: {
    data: [],
    filteredData: [],
    total: 1,
    isLoading: false,
    params: {},
    allData: [],
    selectedUser: null,
    customers: []
  },
  reducers: {
    getData(state, action) {
      const { q, page, perPage, selectedCustomers, sort, sortColumn } = action.payload
      const currentState = current(state)
      const query = (q || '').toLowerCase()
      const selectedCustomersIds = selectedCustomers.map(sc => sc.value)

      const matches = u => (!query 
        || u.fullName.toLowerCase().includes(query) 
        || u.email.toLowerCase().includes(query) 
        || u.title?.toLowerCase().includes(query)
        || u.customers.filter(c => c.name.toLowerCase().includes(query)).length > 0)
        && (!selectedCustomersIds.length || u.customers.some(c => selectedCustomersIds.includes(c.id)))

      let filteredUsers = currentState.allData.filter(matches)
      if (sortColumn !== "id") {
        filteredUsers = orderBy(filteredUsers, sortColumn, sort)
      }
      state.filteredData = filteredUsers
      state.params = action.payload
      state.data = paginate(filteredUsers, perPage, page)
      state.total = filteredUsers.length
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getAllData.pending, (state) => {
        state.isLoading = state.data.length === 0
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        const currentState = current(state)
        state.allData = action.payload
        state.filteredData = action.payload
        state.isLoading = false
        state.data = paginate(action.payload, currentState.params.perPage, 1)
        state.total = action.payload.length
      })
      .addCase(getCustomers.fulfilled, (state, action) => {
        state.customers = action.payload
      })
  }
})

const selectSelf = state => state

const usersTotalSelector = createDraftSafeSelector(
  selectSelf,
  (state) => state.filteredData.length
)

const usersBillableSelector = createDraftSafeSelector(
  selectSelf,
  (state) => state.filteredData.filter(u => u.billable).length
)

const usersNonBillableSelector = createDraftSafeSelector(
  selectSelf,
  (state) => state.filteredData.filter(u => !u.billable).length
)

export const { getData } = appUsersSlice.actions

export { usersTotalSelector, usersBillableSelector, usersNonBillableSelector }

export default appUsersSlice.reducer
